import React from "react";
import OmanBloreCertMain from "./OmanBloreCertMain";
import AustraliaBloreCertHead from "./../../Australia/AustraliaBloreCert/AustraliaBloreCertHead";
import "./../../UaeAttestation/UaeService/UaeService.css";

const OmanBloreCert = () => {
  return (
    <div className="uaeServiceContainer">
      <AustraliaBloreCertHead head="Oman Apostille service in Bangalore for certificates" />
      <OmanBloreCertMain />
    </div>
  );
};

export default OmanBloreCert;
